module.exports = __webpack_public_path__ + "img/satellite-dish-solid.5558ca34.png";